<template>
    <div class="text-center">
        <button
            class="button button-ghost"
            :disabled="loading"
            @click.prevent="emit('loadMore')"
        >
            Load More
            <template v-if="loading">
                <Loader class="bsdc:size-4!" />
            </template>
        </button>
    </div>
</template>

<script setup>
    import Loader from "@js/Components/Loader.vue";

    defineProps({
        loading: Boolean,
    });

    const emit = defineEmits(['loadMore']);
</script>
